import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import EmailAddressSchema, { EmailAddressJSON, EmailAddressParams } from "_shared/email-addresses/email-address-schema";

export default class EmailAddress {
  public static readonly VALID_EMAIL_FORMAT_MESSAGE = "Must be in the format of [account]@[domain].[tld]";
  public static create(email: string): EmailAddress {
    const parsed = EmailAddressSchema.validate(email);
    return new EmailAddress(parsed);
  }

  public static fromJSON(json: unknown): EmailAddress | null | undefined {
    if (isNullOrUndefined(json)) return json;
    const params = EmailAddressSchema.deserialize(json);
    return new EmailAddress(params);
  }

  public constructor(public readonly value: EmailAddressParams) {
    try {
      EmailAddressSchema.validate(value, false);
    } catch {
      throw new InvalidEmailAddressError(EmailAddress.VALID_EMAIL_FORMAT_MESSAGE, value);
    }
  }

  public toJSON(): EmailAddressJSON {
    return EmailAddressSchema.serialize(this.value);
  }

  public valueOf(): string {
    return this.value ?? "";
  }

  public isEqualTo(other: EmailAddress | null | undefined): boolean {
    return this.value === other?.value;
  }

  public toString(): string {
    return this.value ?? "undefined";
  }
}

export class InvalidEmailAddressError extends Error {
  constructor(public readonly userFriendlyMessage: string, value: unknown) {
    super(`${userFriendlyMessage}${value ? ':' : ''} ${value}`);
  }
}
